module.exports = [
  ...require('./_gearRawList_b'),
  require('./battleaxe'),
  require('./bomb'),
  require('./bullets'),
  require('./bullets_modern'),
]
